export default __webpack_public_path__ + "static/media/swiftstrikes4.70044211.png";